export default __webpack_public_path__ + "static/media/sushi3.1e29954b.png";